module.exports = __webpack_public_path__ + "static/media/ride-thumb.eb858b07.png";